module.exports = __webpack_public_path__ + "static/media/Caramel.2f4fa52d.jpg";